import { render, staticRenderFns } from "./Form20Reasons.vue?vue&type=template&id=436e4330&scoped=true&"
import script from "./Form20Reasons.vue?vue&type=script&lang=js&"
export * from "./Form20Reasons.vue?vue&type=script&lang=js&"
import style0 from "./Form20Reasons.vue?vue&type=style&index=0&id=436e4330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436e4330",
  null
  
)

export default component.exports